import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LandslideIcon(props: IconProps) {
    return <Icon {...props} iconKey={"landslide"}/>
}
